export const dateFormat = 'YYYY-MM-DD';
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const DATE_PICKER_DATE_FORMAT = 'DD-MMM-YYYY'
export const DATE_PICKER_MONTH_FORMAT = 'YYYY-MM'
export const DATE_PICKER_TIME_FORMAT = 'HH:mm:ss'

export const REACT_APP_PROJECT_URL = 'http://staging.itagama.com/'
